"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[397],{

/***/ 2397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ei": function() { return /* reexport */ Exchange; },
  "r0": function() { return /* reexport */ Exchanges; },
  "oP": function() { return /* reexport */ ForgotPassword; },
  "SK": function() { return /* reexport */ Home; },
  "QI": function() { return /* reexport */ UserProducts; },
  "cf": function() { return /* reexport */ Request; },
  "Iw": function() { return /* reexport */ UserProfile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sweetalert2/dist/sweetalert2.all.js
var sweetalert2_all = __webpack_require__(6455);
var sweetalert2_all_default = /*#__PURE__*/__webpack_require__.n(sweetalert2_all);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/firebase/database/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(6256);
// EXTERNAL MODULE: ./node_modules/firebase/storage/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(1153);
// EXTERNAL MODULE: ./node_modules/avilatek-utils/dist/avilatek-utils.esm.js
var avilatek_utils_esm = __webpack_require__(3628);
;// CONCATENATED MODULE: ./public/assets/lib/stores.ts
const Stores = [
    {
        id: 1,
        name: "Arquiconstructores",
        city: "Caracas",
        state: "Miranda",
        address: "C.C Casa Mall. Los Naranjos"
    },
    {
        id: 2,
        name: "Decoraciones 360",
        city: "El Tigre",
        state: "Anzoategui",
        address: "Av. Jesus Subuero C.C Amarillo"
    },
    {
        id: 3,
        name: "Porcelana La Pastora",
        city: "Caracas",
        state: "Miranda",
        address: "C.C.C.T Chuao"
    },
    {
        id: 4,
        name: "Porcelana La Pastora",
        city: "Caracas",
        state: "Miranda",
        address: "Av. Orinoco Las Mercedes"
    },
    {
        id: 5,
        name: "Porcelana La Pastora",
        city: "Caracas",
        state: "Miranda",
        address: "Av. Venezuela y Casanova, el Recreo"
    },
    {
        id: 6,
        name: "Porcelana La Pastora",
        city: "Caracas",
        state: "Miranda",
        address: "La Guaira, Los Corales."
    },
    {
        id: 7,
        name: "Dekasa Hogar",
        city: "Maracaibo",
        state: "Zulia",
        address: "Av. 8 Santa Rita, Maracaibo"
    },
    {
        id: 8,
        name: "Spazio Desing",
        city: "Maracaibo",
        state: "Zulia",
        address: "Calle 79, Sector Belloso, Maracaibo"
    },
    {
        id: 9,
        name: "Novalart",
        city: "Caracas",
        state: "Miranda",
        address: "Av. Principal de Chuao"
    },
    {
        id: 10,
        name: "Proyecto T18",
        city: "Caracas",
        state: "Miranda",
        address: "C.C.C.T Chuao"
    },
    {
        id: 11,
        name: "La Porcelana",
        city: "Puerto Ordaz",
        state: "Bolivar",
        address: "UD. 283, Parcelamiento Industrial"
    },
    {
        id: 12,
        name: "Inova",
        city: "Cagua",
        state: "Aragua",
        address: "Carretera Nacional Cagua, La Villa"
    },
    {
        id: 13,
        name: "Inova",
        city: "Maracay",
        state: "Aragua",
        address: "Av. Las Delicias C.C Oram V"
    },
    {
        id: 14,
        name: "Tu Ceramica",
        city: "Caracas",
        state: "Miranda",
        address: "C.C Galeria Prados del Este"
    },
    {
        id: 15,
        name: "Deko Styl",
        city: "Caracas",
        state: "Miranda",
        address: "C.C.C.T Chuao"
    },
    {
        id: 16,
        name: "Arredo Xpress",
        city: "Caracas",
        state: "Miranda",
        address: "Calle Paris, Las Mercedes"
    },
    {
        id: 17,
        name: "Porcelana La Pastora",
        city: "Caracas",
        state: "Miranda",
        address: "Av. Venezuela y Casanova, el Recreo"
    },
    {
        id: 18,
        name: "Himalaya",
        city: "PTO La Cruz",
        state: "Anzoategui",
        address: "Av. Jorge Rodriguez"
    },
    {
        id: 19,
        name: "Centro Homy",
        city: "Caracas",
        state: "Miranda",
        address: "C.C Santa Fe, Baruta"
    },
    {
        id: 20,
        name: "Euro Ba\xf1os",
        city: "Caracas",
        state: "Miranda",
        address: "Av. Casanova, Bello Monte"
    },
    {
        id: 21,
        name: "Rydaca",
        city: "Lecheria",
        state: "Anzoategui",
        address: "C.C Costanera Lecheria"
    },
    {
        id: 22,
        name: "Santa Clara",
        city: "Boto",
        state: "Lara",
        address: "Calle 4, Av. Lara / Carrera 1"
    },
    {
        id: 23,
        name: "Ceramicas del Norte",
        city: "Valencia",
        state: "Carabobo",
        address: "Av. Carabobo Nro 141-91"
    },
    {
        id: 24,
        name: "Total Pisos",
        city: "Caracas",
        state: "Miranda",
        address: "Av. Luis de Camoens, Edf Torre Express"
    },
    {
        id: 25,
        name: "Super Ba\xf1os",
        city: "Caracas",
        state: "Miranda",
        address: "Calle Orinoco, Las Mercedes"
    },
    {
        id: 26,
        name: "Dr Ba\xf1os",
        city: "Caracas",
        state: "Miranda",
        address: "Av. Principal La Urbina"
    },
    {
        id: 27,
        name: "Keops",
        city: "Lecheria",
        state: "Anzoategui",
        address: ""
    },
    {
        id: 28,
        name: "DG Group PZO",
        city: "PTO Ordaz",
        state: "Bolivar",
        address: "C.C Costa America"
    },
    {
        id: 29,
        name: "Roca del Este",
        city: "Caracas",
        state: "Miranda",
        address: "Los Naranjos"
    }
];

// EXTERNAL MODULE: ./lib/firebase.ts + 1 modules
var firebase = __webpack_require__(7818);
;// CONCATENATED MODULE: ./components/pages/exchanges/reducer.ts
function buildInitialState() {
    return {
        image: null,
        store: "none",
        urlImg: "",
        attention: "5",
        seller: "none",
        sellerInfo: "seller",
        project: "none",
        otherProject: "Otro",
        benefitProject: "No",
        uploadValue: 0,
        numberId: "",
        finalClient: {
            name: "",
            dni: "",
            phone: "",
            email: ""
        },
        architect: {
            name: "",
            dni: "",
            phone: "",
            email: ""
        },
        productMts: [
            {
                product: "none",
                mts2: ""
            }
        ]
    };
}
const ACTIONS_TYPES = {
    IMAGE: "IMAGE",
    STORE: "STORE",
    URL_IMAGE: "URL_IMAGE",
    ATTENTION: "ATTENTION",
    SELLER: "SELLER",
    SELLER_INFO: "SELLER_INFO",
    PROJECT: "PROJECT",
    OTHER_PROJECT: "OTHER_PROJECT",
    BENEFIT_PROJECT: "BENEFIT_PROJECT",
    UPLOAD_VALUE: "UPLOAD_VALUE",
    NUMBER_ID: "NUMBER_ID",
    FINAL_CLIENT: "FINAL_CLIENT",
    FINAL_CLIENT_NAME: "FINAL_CLIENT_NAME",
    FINAL_CLIENT_DNI: "FINAL_CLIENT_DNI",
    FINAL_CLIENT_EMAIL: "FINAL_CLIENT_EMAIL",
    FINAL_CLIENT_PHONE: "FINAL_CLIENT_PHONE",
    ARCHITECT: "ARCHITECT",
    ARCHITECT_NAME: "ARCHITECT_NAME",
    ARCHITECT_DNI: "ARCHITECT_DNI",
    ARCHITECT_EMAIL: "ARCHITECT_EMAIL",
    ARCHITECT_PHONE: "ARCHITECT_PHONE",
    PRODUCTS_ACQUIRE: "PRODUCTS_ACQUIRE",
    PRODUCTS_ACQUIRE_PRODUCT: "PRODUCTS_ACQUIRE_PRODUCT",
    PRODUCTS_ACQUIRE_MTS2: "PRODUCTS_ACQUIRE_MTS2",
    PRODUCTS_ACQUIRE_DELETE_PRODUCT: "PRODUCTS_ACQUIRE_DELETE_PRODUCT"
};
function reducer(state, action) {
    switch(action.type){
        case ACTIONS_TYPES.IMAGE:
            return {
                ...state,
                image: action.payload
            };
        case ACTIONS_TYPES.STORE:
            return {
                ...state,
                store: action.payload
            };
        case ACTIONS_TYPES.URL_IMAGE:
            return {
                ...state,
                urlImg: action.payload
            };
        case ACTIONS_TYPES.ATTENTION:
            return {
                ...state,
                attention: action.payload
            };
        case ACTIONS_TYPES.SELLER:
            return {
                ...state,
                seller: action.payload
            };
        case ACTIONS_TYPES.SELLER_INFO:
            return {
                ...state,
                sellerInfo: action.payload
            };
        case ACTIONS_TYPES.PROJECT:
            return {
                ...state,
                project: action.payload
            };
        case ACTIONS_TYPES.OTHER_PROJECT:
            return {
                ...state,
                otherProject: action.payload
            };
        case ACTIONS_TYPES.BENEFIT_PROJECT:
            return {
                ...state,
                benefitProject: action.payload
            };
        case ACTIONS_TYPES.UPLOAD_VALUE:
            return {
                ...state,
                uploadValue: action.payload
            };
        case ACTIONS_TYPES.NUMBER_ID:
            return {
                ...state,
                numberId: action.payload
            };
        case ACTIONS_TYPES.FINAL_CLIENT:
            return {
                ...state,
                finalClient: action.payload
            };
        case ACTIONS_TYPES.PRODUCTS_ACQUIRE:
            return {
                ...state,
                productMts: action.payload
            };
        case ACTIONS_TYPES.PRODUCTS_ACQUIRE_DELETE_PRODUCT:
            var _state_productMts, _state_productMts1;
            var _state_productMts_slice, _state_productMts_slice1;
            return {
                ...state,
                productMts: [
                    ...(_state_productMts_slice = state === null || state === void 0 ? void 0 : (_state_productMts = state.productMts) === null || _state_productMts === void 0 ? void 0 : _state_productMts.slice(0, action.payload.idx)) !== null && _state_productMts_slice !== void 0 ? _state_productMts_slice : [],
                    ...(_state_productMts_slice1 = state === null || state === void 0 ? void 0 : (_state_productMts1 = state.productMts) === null || _state_productMts1 === void 0 ? void 0 : _state_productMts1.slice(action.payload.idx + 1)) !== null && _state_productMts_slice1 !== void 0 ? _state_productMts_slice1 : []
                ]
            };
        case ACTIONS_TYPES.PRODUCTS_ACQUIRE_PRODUCT:
            var _state_productMts2, _state_productMts3, _state_productMts4;
            var _state_productMts_slice2, _state_productMts_action_payload_idx, _state_productMts_slice3;
            return {
                ...state,
                productMts: [
                    ...(_state_productMts_slice2 = state === null || state === void 0 ? void 0 : (_state_productMts2 = state.productMts) === null || _state_productMts2 === void 0 ? void 0 : _state_productMts2.slice(0, action.payload.idx)) !== null && _state_productMts_slice2 !== void 0 ? _state_productMts_slice2 : [],
                    {
                        ...(_state_productMts_action_payload_idx = state === null || state === void 0 ? void 0 : (_state_productMts3 = state.productMts) === null || _state_productMts3 === void 0 ? void 0 : _state_productMts3[action.payload.idx]) !== null && _state_productMts_action_payload_idx !== void 0 ? _state_productMts_action_payload_idx : {},
                        product: action.payload.data
                    },
                    ...(_state_productMts_slice3 = state === null || state === void 0 ? void 0 : (_state_productMts4 = state.productMts) === null || _state_productMts4 === void 0 ? void 0 : _state_productMts4.slice(action.payload.idx + 1)) !== null && _state_productMts_slice3 !== void 0 ? _state_productMts_slice3 : []
                ]
            };
        case ACTIONS_TYPES.PRODUCTS_ACQUIRE_MTS2:
            var _state_productMts5, _state_productMts6, _state_productMts7;
            var _state_productMts_slice4, _state_productMts_action_payload_idx1, _state_productMts_slice5;
            return {
                ...state,
                productMts: [
                    ...(_state_productMts_slice4 = state === null || state === void 0 ? void 0 : (_state_productMts5 = state.productMts) === null || _state_productMts5 === void 0 ? void 0 : _state_productMts5.slice(0, action.payload.idx)) !== null && _state_productMts_slice4 !== void 0 ? _state_productMts_slice4 : [],
                    {
                        ...(_state_productMts_action_payload_idx1 = state === null || state === void 0 ? void 0 : (_state_productMts6 = state.productMts) === null || _state_productMts6 === void 0 ? void 0 : _state_productMts6[action.payload.idx]) !== null && _state_productMts_action_payload_idx1 !== void 0 ? _state_productMts_action_payload_idx1 : {},
                        mts2: action.payload.data
                    },
                    ...(_state_productMts_slice5 = state === null || state === void 0 ? void 0 : (_state_productMts7 = state.productMts) === null || _state_productMts7 === void 0 ? void 0 : _state_productMts7.slice(action.payload.idx + 1)) !== null && _state_productMts_slice5 !== void 0 ? _state_productMts_slice5 : []
                ]
            };
        case ACTIONS_TYPES.FINAL_CLIENT_NAME:
            var _state_finalClient;
            return {
                ...state,
                finalClient: {
                    ...(_state_finalClient = state.finalClient) !== null && _state_finalClient !== void 0 ? _state_finalClient : {},
                    name: action.payload
                }
            };
        case ACTIONS_TYPES.FINAL_CLIENT_DNI:
            var _state_finalClient1;
            return {
                ...state,
                finalClient: {
                    ...(_state_finalClient1 = state.finalClient) !== null && _state_finalClient1 !== void 0 ? _state_finalClient1 : {},
                    dni: action.payload
                }
            };
        case ACTIONS_TYPES.FINAL_CLIENT_EMAIL:
            var _state_finalClient2;
            return {
                ...state,
                finalClient: {
                    ...(_state_finalClient2 = state.finalClient) !== null && _state_finalClient2 !== void 0 ? _state_finalClient2 : {},
                    email: action.payload
                }
            };
        case ACTIONS_TYPES.FINAL_CLIENT_PHONE:
            var _state_finalClient3;
            return {
                ...state,
                finalClient: {
                    ...(_state_finalClient3 = state.finalClient) !== null && _state_finalClient3 !== void 0 ? _state_finalClient3 : {},
                    phone: action.payload
                }
            };
        case ACTIONS_TYPES.ARCHITECT:
            return {
                ...state,
                architect: action.payload
            };
        case ACTIONS_TYPES.ARCHITECT_NAME:
            var _state_architect;
            return {
                ...state,
                architect: {
                    ...(_state_architect = state.architect) !== null && _state_architect !== void 0 ? _state_architect : {},
                    name: action.payload
                }
            };
        case ACTIONS_TYPES.ARCHITECT_DNI:
            var _state_architect1;
            return {
                ...state,
                architect: {
                    ...(_state_architect1 = state.architect) !== null && _state_architect1 !== void 0 ? _state_architect1 : {},
                    dni: action.payload
                }
            };
        case ACTIONS_TYPES.ARCHITECT_EMAIL:
            var _state_architect2;
            return {
                ...state,
                architect: {
                    ...(_state_architect2 = state.architect) !== null && _state_architect2 !== void 0 ? _state_architect2 : {},
                    email: action.payload
                }
            };
        case ACTIONS_TYPES.ARCHITECT_PHONE:
            var _state_architect3;
            return {
                ...state,
                architect: {
                    ...(_state_architect3 = state.architect) !== null && _state_architect3 !== void 0 ? _state_architect3 : {},
                    phone: action.payload
                }
            };
        default:
            return {
                ...state
            };
    }
}

// EXTERNAL MODULE: ./hooks/index.ts + 3 modules
var hooks = __webpack_require__(9550);
// EXTERNAL MODULE: ./components/layout/UserLayout.tsx
var UserLayout = __webpack_require__(8701);
;// CONCATENATED MODULE: ./components/pages/exchanges/Exchange.tsx
/* eslint-disable @next/next/no-img-element */ 












function Exchange() {
    var _state_productMts, _state_productMts1, _state_image;
    const router = (0,next_router.useRouter)();
    const [user] = (0,hooks/* useUser */.aF)();
    const [state, dispatch] = react.useReducer(reducer, buildInitialState());
    const [products, setProducts] = react.useState([]);
    const [employees, setEmployees] = react.useState([]);
    react.useEffect(function syncEmployees() {
        const unsubscribe = (0,index_esm/* onValue */.jM)((0,index_esm/* query */.IO)((0,index_esm/* ref */.iH)(firebase/* database */.Fs, "users"), (0,index_esm/* orderByChild */.g2)("status"), (0,index_esm/* equalTo */.EW)(2)), (snapshot)=>{
            const data = [];
            const storeData = new Set();
            if (snapshot.exists()) {
                snapshot.forEach((child)=>{
                    const val = child.val();
                    if ((val === null || val === void 0 ? void 0 : val.status) === 2) {
                        data.push({
                            ...val,
                            key: child.key
                        });
                        storeData.add(val.store);
                    }
                });
                setEmployees(data);
            }
        });
        return ()=>{
            if (unsubscribe) {
                unsubscribe();
            }
        };
    }, []);
    react.useEffect(function syncProducts() {
        const _products = [];
        const unsubscribe = (0,index_esm/* onValue */.jM)((0,index_esm/* ref */.iH)(firebase/* database */.Fs, "products"), (snapshot)=>{
            if (snapshot.exists()) {
                snapshot.forEach((item)=>{
                    _products.push(item.val());
                });
            }
            var _products_sort;
            setProducts((_products_sort = _products === null || _products === void 0 ? void 0 : _products.sort((a, b)=>a.name > b.name ? -1 : 1)) !== null && _products_sort !== void 0 ? _products_sort : []);
        });
        return ()=>{
            if (unsubscribe) {
                unsubscribe();
            }
        };
    }, []);
    const onChange = (e)=>{
        e.preventDefault();
        dispatch({
            type: e.target.name,
            payload: e.target.value
        });
    };
    const removeUpload = ()=>{
        document.getElementById("upload_content").style.display = "none";
        document.getElementById("upload_wrap").hidden = false;
        document.getElementById("preview_image").setAttribute("src", "/");
        dispatch({
            type: ACTIONS_TYPES.IMAGE,
            payload: null
        });
        dispatch({
            type: ACTIONS_TYPES.URL_IMAGE,
            payload: ""
        });
        dispatch({
            type: ACTIONS_TYPES.UPLOAD_VALUE,
            payload: 0
        });
    };
    const readUrl = async (e)=>{
        var _e_target, _e_target_files;
        e.preventDefault();
        const file = e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_files = _e_target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0];
        if (file) {
            dispatch({
                type: ACTIONS_TYPES.IMAGE,
                payload: file
            });
            const task = (0,dist_index_esm/* uploadBytesResumable */.B0)((0,dist_index_esm/* ref */.iH)(firebase/* storage */.tO, "solicitudes/".concat(file.name)), file);
            task.on("state_changed", (snapshot)=>{
                const percentage = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                dispatch({
                    type: ACTIONS_TYPES.UPLOAD_VALUE,
                    payload: percentage
                });
            }, (error)=>{
                console.log(error);
            }, ()=>{
                (0,dist_index_esm/* getDownloadURL */.Jt)(task.snapshot.ref).then((url)=>{
                    dispatch({
                        type: ACTIONS_TYPES.URL_IMAGE,
                        payload: url
                    });
                    document.getElementById("upload_wrap").hidden = true;
                    document.getElementById("preview_image").setAttribute("src", URL.createObjectURL(file));
                    document.getElementById("upload_content").style.display = "block";
                });
            });
        } else {
            removeUpload();
        }
    };
    const sendImage = async (e)=>{
        try {
            e.preventDefault();
            if (!(0,avilatek_utils_esm/* validateString */.Cp)(state.store) || state.store === "none") {
                sweetalert2_all_default().fire({
                    icon: "error",
                    text: "Seleccione una tienda"
                });
                return;
            }
            if (!(0,avilatek_utils_esm/* validateString */.Cp)(state.seller) || state.seller === "none") {
                sweetalert2_all_default().fire({
                    icon: "error",
                    text: "Ingrese el nombre del vendedor"
                });
                return;
            }
            if (!(0,avilatek_utils_esm/* validateString */.Cp)(state.attention)) {
                sweetalert2_all_default().fire({
                    icon: "error",
                    text: "Seleccione un nivel de atenci\xf3n"
                });
                return;
            }
            if (!(0,avilatek_utils_esm/* validateString */.Cp)(state.project)) {
                sweetalert2_all_default().fire({
                    icon: "error",
                    text: "Ingrese un nombre del proyecto"
                });
                return;
            }
            if (!state.image || !(0,avilatek_utils_esm/* validateString */.Cp)(state.urlImg)) {
                sweetalert2_all_default().fire({
                    icon: "error",
                    text: "Ingrese una imagen del proyecto"
                });
                return;
            }
            // if (!validateProducts(state.productMts)) {
            //   Swal.fire({
            //     icon: 'error',
            //     text: `Hay un error en los productos`,
            //   });
            //   return;
            // }
            if (!(0,avilatek_utils_esm/* validateString */.Cp)(state.numberId)) {
                sweetalert2_all_default().fire({
                    icon: "error",
                    text: "Ingrese un n\xfamero de documento"
                });
                return;
            }
            const date = new Date();
            const result = await sweetalert2_all_default().fire({
                title: "\xbfEstas seguro?",
                text: "Su solicitud sera enviada para abonarle los puntos obtenidos",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Enviar solicitud"
            });
            if (result.value) {
                const newRequestRef = (0,index_esm/* push */.VF)((0,index_esm/* ref */.iH)(firebase/* database */.Fs, "requets"));
                var _state_finalClient, _state_architect, _state_benefitProject;
                await (0,index_esm/* update */.Vx)(newRequestRef.ref, {
                    id: newRequestRef.key,
                    img: state.urlImg,
                    id_user: user.idUser,
                    date: dayjs_min_default()(date).format("DD/MM/YYYY"),
                    store: state.store,
                    status: "procesando",
                    attention: state.attention,
                    purchase: state.productMts,
                    number_bill: state.numberId,
                    seller: state.seller,
                    project_type: (0,avilatek_utils_esm/* validateString */.Cp)(state.otherProject) ? state.otherProject : state.project,
                    client_final: [
                        {
                            ...(_state_finalClient = state.finalClient) !== null && _state_finalClient !== void 0 ? _state_finalClient : {},
                            type: "Cliente"
                        },
                        {
                            ...(_state_architect = state.architect) !== null && _state_architect !== void 0 ? _state_architect : {},
                            type: "Arquitecto / Dise\xf1ador"
                        }
                    ] || 0,
                    benefictProject: (_state_benefitProject = state.benefitProject) !== null && _state_benefitProject !== void 0 ? _state_benefitProject : ""
                });
                await router.push("/user/request");
            }
        } catch (err) {
            console.log(err);
            sweetalert2_all_default().fire({
                icon: "error",
                text: "Ha ocurrido un error al guardar la informaci\xf3n"
            });
        }
    };
    const addProduct = react.useCallback((e)=>{
        e.preventDefault();
        var _state_productMts;
        dispatch({
            type: ACTIONS_TYPES.PRODUCTS_ACQUIRE,
            payload: [
                ...(_state_productMts = state === null || state === void 0 ? void 0 : state.productMts) !== null && _state_productMts !== void 0 ? _state_productMts : [],
                {
                    product: "none",
                    mts2: ""
                }
            ]
        });
    }, [
        state.productMts
    ]);
    const removeProduct = react.useCallback((e)=>{
        e.preventDefault();
        const { id  } = e.currentTarget.dataset;
        dispatch({
            type: ACTIONS_TYPES.PRODUCTS_ACQUIRE_DELETE_PRODUCT,
            payload: {
                idx: Number(id)
            }
        });
    }, []);
    var _product_name, _product_name1, _product_code, _state_productMts_length, _state_image_name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            method: "POST",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row justify-content-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "card rounded-lg shadow-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "card-headerbc",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "text-center py-4",
                                            children: "Registro del documento de compra en Habitat Venezuela"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-justify py-2 px-4",
                                            children: "La solicitud de Habitat Coins consiste en registrar datos relacionados con la compra de productos Habitat Venezuela. Una vez realizada la solicitud debes esperar 72 horas para que sea aprobada y de esta manera obtener los Habitat Coins que correspondan seg\xfan tu compra y que luego podr\xe1s canjear por productos o servicios especiales."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "card-body",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: ACTIONS_TYPES.STORE,
                                                        children: "Nombre de la tienda:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                        id: ACTIONS_TYPES.STORE,
                                                        name: ACTIONS_TYPES.STORE,
                                                        className: "form-control",
                                                        onChange: onChange,
                                                        value: state.store,
                                                        required: true,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "none",
                                                                disabled: true,
                                                                children: "Selecciona una tienda"
                                                            }),
                                                            Stores === null || Stores === void 0 ? void 0 : Stores.map((_store)=>{
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("option", {
                                                                    value: _store === null || _store === void 0 ? void 0 : _store.name,
                                                                    children: [
                                                                        _store === null || _store === void 0 ? void 0 : _store.name,
                                                                        " - ",
                                                                        _store === null || _store === void 0 ? void 0 : _store.city,
                                                                        " - ",
                                                                        _store === null || _store === void 0 ? void 0 : _store.address
                                                                    ]
                                                                }, _store === null || _store === void 0 ? void 0 : _store.name);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: ACTIONS_TYPES.SELLER,
                                                        children: "Persona que lo atendi\xf3:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                        id: ACTIONS_TYPES.SELLER,
                                                        name: ACTIONS_TYPES.SELLER,
                                                        className: "form-control",
                                                        onChange: onChange,
                                                        value: state.seller,
                                                        required: true,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "none",
                                                                disabled: true,
                                                                children: "Selecciona un vendedor"
                                                            }),
                                                            (employees === null || employees === void 0 ? void 0 : employees.length) > 0 ? employees === null || employees === void 0 ? void 0 : employees.map((seller)=>{
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("option", {
                                                                    value: seller === null || seller === void 0 ? void 0 : seller.key,
                                                                    children: [
                                                                        seller === null || seller === void 0 ? void 0 : seller.first_name,
                                                                        " ",
                                                                        seller === null || seller === void 0 ? void 0 : seller.first_lastname
                                                                    ]
                                                                }, seller === null || seller === void 0 ? void 0 : seller.key);
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                children: "No hay vendedores"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                style: {
                                                    marginTop: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: ACTIONS_TYPES.PROJECT,
                                                        children: "Tipo de proyecto:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                        name: ACTIONS_TYPES.PROJECT,
                                                        id: ACTIONS_TYPES.PROJECT,
                                                        className: "form-control",
                                                        onChange: onChange,
                                                        value: state.project,
                                                        required: true,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "casa",
                                                                children: "Casa"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "apartamento",
                                                                children: "Apartamento"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "oficina",
                                                                children: "Oficina"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "restaurante",
                                                                children: "Restaurante"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "bodegon",
                                                                children: "Bodeg\xf3n"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "supermercado",
                                                                children: "Supermercado"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "hotel",
                                                                children: "Hotel"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "otro",
                                                                children: "Otro"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            state.project === "otro" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-md-6",
                                                        style: {
                                                            marginTop: "1rem"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: ACTIONS_TYPES.OTHER_PROJECT,
                                                                children: "Especifique"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "text",
                                                                className: "form-control",
                                                                name: ACTIONS_TYPES.OTHER_PROJECT,
                                                                id: ACTIONS_TYPES.OTHER_PROJECT,
                                                                placeholder: "Especifique",
                                                                onChange: onChange,
                                                                required: true
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-6",
                                                        style: {
                                                            marginTop: "1rem"
                                                        }
                                                    })
                                                ]
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                style: {
                                                    marginTop: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: ACTIONS_TYPES.ATTENTION,
                                                        children: "Nivel de atenci\xf3n:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                        id: ACTIONS_TYPES.ATTENTION,
                                                        name: ACTIONS_TYPES.ATTENTION,
                                                        className: "form-control",
                                                        onChange: onChange,
                                                        value: state.attention,
                                                        required: true,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "5",
                                                                children: "Excelente"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "4",
                                                                children: "Muy bien"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "3",
                                                                children: "Bien"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "2",
                                                                children: "Mal"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "1",
                                                                children: "Muy mal"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                style: {
                                                    marginTop: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: ACTIONS_TYPES.NUMBER_ID,
                                                        children: "N\xb0 de documento que soporte la compra:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        id: ACTIONS_TYPES.NUMBER_ID,
                                                        name: ACTIONS_TYPES.NUMBER_ID,
                                                        className: "form-control",
                                                        type: "text",
                                                        onChange: onChange,
                                                        value: state.numberId,
                                                        placeholder: "N\xb0 de documento que soporte la compra",
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                style: {
                                                    marginTop: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: ACTIONS_TYPES.BENEFIT_PROJECT,
                                                        children: "Su proyecto fue beneficiado con alg\xfan descuento de apoyo al sector turismo y/o educacion que otorga la marca a estos rubros?"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                        id: ACTIONS_TYPES.BENEFIT_PROJECT,
                                                        name: ACTIONS_TYPES.BENEFIT_PROJECT,
                                                        onChange: onChange,
                                                        placeholder: "No",
                                                        className: "form-control",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "si",
                                                                children: "Si"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "no",
                                                                children: "No"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            state.productMts.map((_, idx)=>{
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-md-6",
                                                            style: {
                                                                marginTop: "1rem"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "product-".concat(idx),
                                                                    children: "Producto"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                                    name: "product-".concat(idx),
                                                                    id: "product-".concat(idx),
                                                                    className: "form-control",
                                                                    "data-id": idx,
                                                                    onChange: (e)=>{
                                                                        e.preventDefault();
                                                                        dispatch({
                                                                            type: ACTIONS_TYPES.PRODUCTS_ACQUIRE_PRODUCT,
                                                                            payload: {
                                                                                idx,
                                                                                data: e.target.value
                                                                            }
                                                                        });
                                                                    },
                                                                    defaultValue: "none",
                                                                    required: true,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "none",
                                                                            disabled: true,
                                                                            children: "Seleccione un producto"
                                                                        }),
                                                                        products.map((product)=>{
                                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                                                value: (_product_name = product === null || product === void 0 ? void 0 : product.name) !== null && _product_name !== void 0 ? _product_name : "",
                                                                                children: (_product_name1 = product === null || product === void 0 ? void 0 : product.name) !== null && _product_name1 !== void 0 ? _product_name1 : ""
                                                                            }, (_product_code = product === null || product === void 0 ? void 0 : product.code) !== null && _product_code !== void 0 ? _product_code : "");
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-md-6",
                                                            style: {
                                                                marginTop: "1rem"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "mt2-".concat(idx),
                                                                    children: "Metros cuadrados:"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "text",
                                                                    name: "mt2-".concat(idx),
                                                                    id: "mt2-".concat(idx),
                                                                    className: "form-control",
                                                                    "data-id": idx,
                                                                    onChange: (e)=>{
                                                                        e.preventDefault();
                                                                        dispatch({
                                                                            type: ACTIONS_TYPES.PRODUCTS_ACQUIRE_MTS2,
                                                                            payload: {
                                                                                idx,
                                                                                data: e.target.value
                                                                            }
                                                                        });
                                                                    },
                                                                    required: true
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, idx);
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-12",
                                                style: {
                                                    marginTop: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: "btn btn-default",
                                                        style: {
                                                            float: "right"
                                                        },
                                                        onClick: addProduct,
                                                        type: "button",
                                                        children: "Agregar Producto"
                                                    }),
                                                    ((_state_productMts = state.productMts) === null || _state_productMts === void 0 ? void 0 : _state_productMts.length) > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: "btn btn-default mx-3",
                                                        style: {
                                                            float: "right"
                                                        },
                                                        onClick: removeProduct,
                                                        "data-id": ((_state_productMts_length = (_state_productMts1 = state.productMts) === null || _state_productMts1 === void 0 ? void 0 : _state_productMts1.length) !== null && _state_productMts_length !== void 0 ? _state_productMts_length : 1) - 1,
                                                        type: "button",
                                                        children: "Eliminar Producto"
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                style: {
                                                    marginTop: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: ACTIONS_TYPES.FINAL_CLIENT_NAME,
                                                        children: "Nombre del cliente final del proyecto (opcional)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        id: ACTIONS_TYPES.FINAL_CLIENT_NAME,
                                                        name: ACTIONS_TYPES.FINAL_CLIENT_NAME,
                                                        type: "text",
                                                        className: "form-control",
                                                        placeholder: "Nombre del cliente final del proyecto (opcional)",
                                                        value: state.finalClient.name,
                                                        onChange: onChange
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                style: {
                                                    marginTop: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: ACTIONS_TYPES.FINAL_CLIENT_DNI,
                                                        children: "C\xe9dula del cliente final del proyecto (opcional)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        id: ACTIONS_TYPES.FINAL_CLIENT_DNI,
                                                        name: ACTIONS_TYPES.FINAL_CLIENT_DNI,
                                                        type: "text",
                                                        className: "form-control",
                                                        placeholder: "C\xe9dula del cliente final del proyecto (opcional)",
                                                        value: state.finalClient.dni,
                                                        onChange: onChange
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                style: {
                                                    marginTop: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: ACTIONS_TYPES.FINAL_CLIENT_PHONE,
                                                        children: "Tel\xe9fono del cliente final del proyecto (opcional)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        id: ACTIONS_TYPES.FINAL_CLIENT_PHONE,
                                                        name: ACTIONS_TYPES.FINAL_CLIENT_PHONE,
                                                        type: "text",
                                                        className: "form-control",
                                                        placeholder: "Tel\xe9fono del cliente final del proyecto (opcional)",
                                                        value: state.finalClient.phone,
                                                        onChange: onChange
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                style: {
                                                    marginTop: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: ACTIONS_TYPES.FINAL_CLIENT_EMAIL,
                                                        children: "Correo Electr\xf3nico del cliente final del proyecto (opcional)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        id: ACTIONS_TYPES.FINAL_CLIENT_EMAIL,
                                                        name: ACTIONS_TYPES.FINAL_CLIENT_EMAIL,
                                                        type: "email",
                                                        className: "form-control",
                                                        placeholder: "Correo Electr\xf3nico del cliente final del proyecto (opcional)",
                                                        value: state.finalClient.email,
                                                        onChange: onChange
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                style: {
                                                    marginTop: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: ACTIONS_TYPES.ARCHITECT_NAME,
                                                        children: "Nombre del Arquitecto / Dise\xf1ador del proyecto (opcional)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        id: ACTIONS_TYPES.ARCHITECT_NAME,
                                                        name: ACTIONS_TYPES.ARCHITECT_NAME,
                                                        type: "text",
                                                        className: "form-control",
                                                        placeholder: "Nombre del Arquitecto / Dise\xf1ador del proyecto (opcional)",
                                                        value: state.architect.name,
                                                        onChange: onChange
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                style: {
                                                    marginTop: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: ACTIONS_TYPES.ARCHITECT_DNI,
                                                        children: "C\xe9dula del Arquitecto / Dise\xf1ador del proyecto (opcional)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        id: ACTIONS_TYPES.ARCHITECT_DNI,
                                                        name: ACTIONS_TYPES.ARCHITECT_DNI,
                                                        type: "text",
                                                        className: "form-control",
                                                        placeholder: "C\xe9dula del Arquitecto / Dise\xf1ador del proyecto (opcional)",
                                                        value: state.architect.dni,
                                                        onChange: onChange
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                style: {
                                                    marginTop: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: ACTIONS_TYPES.ARCHITECT_PHONE,
                                                        children: "Tel\xe9fono del Arquitecto / Dise\xf1ador del proyecto (opcional)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        id: ACTIONS_TYPES.ARCHITECT_PHONE,
                                                        name: ACTIONS_TYPES.ARCHITECT_PHONE,
                                                        type: "text",
                                                        className: "form-control",
                                                        placeholder: "Tel\xe9fono del Arquitecto / Dise\xf1ador del proyecto (opcional)",
                                                        value: state.architect.phone,
                                                        onChange: onChange
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                style: {
                                                    marginTop: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: ACTIONS_TYPES.ARCHITECT_EMAIL,
                                                        children: "Correo Electr\xf3nico del Arquitecto / Dise\xf1ador del proyecto (opcional)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        id: ACTIONS_TYPES.ARCHITECT_EMAIL,
                                                        name: ACTIONS_TYPES.ARCHITECT_EMAIL,
                                                        type: "email",
                                                        className: "form-control",
                                                        placeholder: "Correo Electr\xf3nico del Arquitecto / Dise\xf1ador del proyecto (opcional)",
                                                        value: state.architect.email,
                                                        onChange: onChange
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row justify-content-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-lg-8 col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "file-upload",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "image-upload-wrap",
                                    id: "upload_wrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "file-upload-input",
                                            type: "file",
                                            accept: "image/*, application/pdf",
                                            id: "input",
                                            onChange: readUrl
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "drag-text",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Seleccione su documento que soporte la compra"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "file-upload-content",
                                    id: "upload_content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "file-upload-image",
                                            src: "#",
                                            alt: "factura",
                                            id: "preview_image"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image-title-wrap",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                type: "button",
                                                className: "remove-image",
                                                onClick: removeUpload,
                                                children: [
                                                    "Eliminar",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "image-title",
                                                        children: (_state_image_name = (_state_image = state.image) === null || _state_image === void 0 ? void 0 : _state_image.name) !== null && _state_image_name !== void 0 ? _state_image_name : ""
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "progress",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "progress-bar",
                                                role: "progressbar",
                                                "aria-valuenow": state.uploadValue,
                                                "aria-valuemin": 0,
                                                "aria-valuemax": 100,
                                                style: {
                                                    width: "".concat(state.uploadValue, "%")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "sr-only",
                                                    children: [
                                                        state.uploadValue === 100 ? "Listo" : "Cargando...",
                                                        Math.round(state.uploadValue)
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-sm-10 col-md-10",
                        children: state.image && state.uploadValue === 100 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn btn-default",
                            type: "submit",
                            style: {
                                float: "right"
                            },
                            onClick: sendImage,
                            children: "Enviar"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn btn-default",
                            type: "submit",
                            style: {
                                float: "right"
                            },
                            disabled: true,
                            children: "Enviar"
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(9583);
// EXTERNAL MODULE: ./components/index.tsx + 17 modules
var components = __webpack_require__(748);
;// CONCATENATED MODULE: ./components/pages/exchanges/Exchanges.tsx
/* eslint-disable no-nested-ternary */ 







function Exchanges() {
    const [user] = (0,hooks/* useUser */.aF)();
    const [exchanges, setExchanges] = react.useState([]);
    const { currentPage , setCurrentPage , pageNumbers , items  } = (0,hooks/* usePagination */.h0)(exchanges);
    react.useEffect(function syncExchanges() {
        if (user === null || user === void 0 ? void 0 : user.idUser) {
            (0,index_esm/* onValue */.jM)((0,index_esm/* query */.IO)((0,index_esm/* ref */.iH)(firebase/* database */.Fs, "requets"), (0,index_esm/* orderByChild */.g2)("id_user"), (0,index_esm/* equalTo */.EW)(user.idUser)), (snapshot)=>{
                const data = [];
                snapshot.forEach((child)=>{
                    data.push(child.val());
                });
                setExchanges(data);
            });
        }
    }, [
        user === null || user === void 0 ? void 0 : user.idUser
    ]);
    const handleClick = (e)=>{
        e.preventDefault();
        const { page  } = e.currentTarget.dataset;
        document.getElementById("".concat(currentPage)).classList.remove("active");
        document.getElementById("".concat(page)).classList.add("active");
        setCurrentPage(Number(page));
    };
    const prevPage = (e)=>{
        if (currentPage !== 1) {
            e.preventDefault();
            document.getElementById("".concat(currentPage - 1)).classList.add("active");
            document.getElementById("".concat(currentPage)).classList.remove("active");
            setCurrentPage(currentPage - 1);
        }
    };
    const nextPage = (e)=>{
        if (currentPage !== pageNumbers.length) {
            e.preventDefault();
            document.getElementById("".concat(currentPage + 1)).classList.add("active");
            document.getElementById("".concat(currentPage)).classList.remove("active");
            setCurrentPage(currentPage + 1);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* UserLayout */.rf, {
        children: user ? exchanges && exchanges.length > 0 && items && items.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row justify-content-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "card",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "card-content table-responsive table-full-width",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                    className: "table table-striped",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-center",
                                                            children: "Fecha"
                                                        })
                                                    }, "date"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-center",
                                                            children: "Puntos"
                                                        })
                                                    }, "store"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-center",
                                                            children: "Producto"
                                                        })
                                                    }, "status")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                            children: items.map((exchange, id)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "text-center",
                                                            children: exchange.date
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "text-center",
                                                            children: exchange.points
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "text-center",
                                                            children: exchange.product
                                                        })
                                                    ]
                                                }, id))
                                        })
                                    ]
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row justify-content-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "card-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "pagination",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: prevPage,
                                            role: "button",
                                            tabIndex: 0,
                                            onKeyDown: (e)=>{
                                                e.preventDefault();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                "aria-hidden": true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaArrowCircleLeft */.MZt, {
                                                    size: 20
                                                })
                                            })
                                        })
                                    }),
                                    pageNumbers.map((page)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            id: String(page),
                                            "data-page": page,
                                            onClick: handleClick,
                                            onKeyDown: (e)=>{
                                                e.preventDefault();
                                            },
                                            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                                            role: "button",
                                            tabIndex: 0,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: page
                                            })
                                        }, page)),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: nextPage,
                                            role: "button",
                                            tabIndex: 0,
                                            onKeyDown: (e)=>{
                                                e.preventDefault();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                "aria-hidden": true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaArrowCircleRight */.Wgy, {
                                                    size: 20
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row justify-content-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-lg-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "text-center",
                            children: "No hay ningun producto canjeado"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row justify-content-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/products",
                        className: "btn btn-default",
                        style: {
                            position: "relative",
                            left: "1.5%"
                        },
                        children: "Realizar un canjeo"
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            style: {
                height: "100vh"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row justify-content-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        position: "relative",
                        top: "300px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Spinner */.$j, {
                        text: "Cargando..."
                    })
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/pages/exchanges/index.ts



// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/index.esm.js + 3 modules
var auth_dist_index_esm = __webpack_require__(708);
;// CONCATENATED MODULE: ./components/pages/forgot-password/ForgotPassword.tsx







function ForgotPassword() {
    const [email, setEmail] = react.useState("");
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!(0,avilatek_utils_esm/* validateString */.Cp)(email)) {
            sweetalert2_all_default().fire({
                icon: "error",
                text: "Debe ingresar su correo electr\xf3nico"
            });
            return;
        }
        const _query = (0,index_esm/* query */.IO)((0,index_esm/* ref */.iH)(firebase/* database */.Fs, "users"), (0,index_esm/* orderByChild */.g2)("email"), (0,index_esm/* equalTo */.EW)(email));
        const snapshot = await (0,index_esm/* get */.U2)(_query);
        let verify = false;
        if (snapshot.exists() && snapshot.val().email !== "") {
            verify = true;
        } else {
            verify = false;
        }
        if (verify) {
            await (0,auth_dist_index_esm/* sendPasswordResetEmail */.LS)(firebase/* auth */.I8, email);
            sweetalert2_all_default().fire({
                icon: "success",
                text: "Se ha enviado un link para restablecer tu contrase\xf1a a tu correo:".concat(email)
            });
        } else {
            sweetalert2_all_default().fire({
                icon: "error",
                text: "El correo suministrado: ".concat(email, " no esta registrado en nuestro sistema")
            });
        }
    };
    const handleChange = (e)=>{
        const { name , value  } = e.currentTarget;
        switch(name){
            case "email":
                setEmail(value);
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "card",
            "data-background": "color",
            "data-color": "blue",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card-header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "card-title text-center",
                        children: "Restablecer contrase\xf1a"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "card-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "text-justify",
                                children: "Ingrese su correo electr\xf3nico registrado en nuestra plataforma, donde le estaremos enviando un correo para que pueda restablecer su contrase\xf1a"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            children: "Correo electr\xf3nico"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "email",
                                            value: email,
                                            placeholder: "Enter email",
                                            id: "email",
                                            name: "email",
                                            className: "form-control input-no-border",
                                            onChange: handleChange,
                                            required: true
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card-footer text-center py-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: handleSubmit,
                        className: "btn btn-fill btn-wd",
                        type: "button",
                        children: "Enviar"
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/pages/forgot-password/index.ts


// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(9352);
;// CONCATENATED MODULE: ./components/pages/home/Home.tsx
/* eslint-disable @next/next/no-img-element */ 




const Home_images = [
    "../../assets/img/Banner-1.png",
    "../../assets/img/Banner-2.png",
    "../../assets/img/Banner-3.png"
];
function Home() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Navbar */.wp, {
                image: "../../assets/img/logoMarketplace.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: "100vh"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Slider */.iR, {
                    images: Home_images,
                    controls: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "services-area pt-120",
                style: {
                    height: "auto",
                    backgroundImage: "url('../../assets/img/indexBackground.jpg')"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "upper-section",
                        id: "steps",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row justify-content-center",
                                    style: {
                                        marginBottom: 15
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "section title text-center pb-40",
                                            style: {
                                                marginTop: "3rem"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "title",
                                                style: {
                                                    color: "black"
                                                },
                                                id: "steps-title",
                                                children: "Pasos para adquirir productos o servicios:"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row justify-content-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-lg-4 col-md-7 col-sm-8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "single-services text-center mt-30",
                                                style: {
                                                    height: "90%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "services-icon"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "services-content mt-30",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    className: "",
                                                                    fill: "none",
                                                                    viewBox: "0 0 24 24",
                                                                    stroke: "currentColor",
                                                                    style: {
                                                                        width: "100px",
                                                                        height: "100px",
                                                                        color: "white",
                                                                        marginLeft: "20px"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round",
                                                                        strokeWidth: 2,
                                                                        d: "M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                className: "services-title text-white",
                                                                children: "Reg\xedstrate"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text",
                                                                children: "Es muy sencillo, solo necesitamos tu informaci\xf3n para que puedas solicitar tus Habitat Coins para luego canjearlos por productos o servicios."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-lg-4 col-md-7 col-sm-8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "single-services text-center mt-30",
                                                style: {
                                                    height: "90%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "services-icon"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "services-content mt-30",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    fill: "none",
                                                                    viewBox: "0 0 24 24",
                                                                    stroke: "currentColor",
                                                                    style: {
                                                                        width: "100px",
                                                                        height: "100px",
                                                                        color: "white",
                                                                        marginLeft: "20px"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round",
                                                                        strokeWidth: 2,
                                                                        d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                className: "services-title text-white",
                                                                children: "Sube tu documento de compra"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text",
                                                                children: "En la secci\xf3n de Solicitud de Habitat Coins debes subir tu factura o cotizaci\xf3n y completar los datos requeridos."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-lg-4 col-md-7 col-sm-8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "single-services text-center mt-30",
                                                style: {
                                                    height: "90%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "services-icon"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "services-content mt-30",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    fill: "none",
                                                                    viewBox: "0 0 24 24",
                                                                    stroke: "currentColor",
                                                                    style: {
                                                                        width: "100px",
                                                                        height: "100px",
                                                                        color: "white",
                                                                        marginLeft: "20px"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round",
                                                                        strokeWidth: 2,
                                                                        d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                className: "services-title text-white",
                                                                children: "Canjea los productos"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text",
                                                                children: "Una vez que sea aprobada tu solicitud, ser\xe1n cargados a tu cuenta los Habitat Coins generados por tu compra. Una vez obtenidos, podr\xe1s canjearlos por productos o servicios de tu preferencia en el Market Place."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-center pb-5",
                        style: {
                            margin: "0rem",
                            color: "black"
                        },
                        id: "marketPlace-title",
                        children: "\xbfQu\xe9 es el Market Place?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        style: {
                            paddingBottom: "6rem",
                            height: "auto"
                        },
                        id: "about",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: "text-center",
                                    id: "textMarketPlace",
                                    children: "Es la plataforma de nuestro programa exclusivo de fidelizaci\xf3n, aqu\xed consentimos a los nuestros, reconocemos el valor y la constancia de cada cliente que contin\xfaa haciendo futuro en Venezuela. Estamos haciendo crecer la familia HABITAT Venezuela, la familia que sigue y seguir\xe1 #PisandoFirme en todo el pa\xeds."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row justify-content-center item-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "../../assets/img/logoMarketplace.png",
                                    alt: "logoMarketPlace",
                                    id: "logoMarketPlaceText",
                                    style: {
                                        marginTop: "2rem"
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                id: "contact",
                style: {
                    backgroundColor: "#17181d",
                    height: "auto",
                    marginTop: "auto"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ContactUs */.Ub, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row mt-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-white",
                                        style: {
                                            margin: "auto",
                                            fontSize: "1rem"
                                        },
                                        id: "text-contact",
                                        children: "INFO@HABITATVENEZUELA.COM"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "100%",
                                        marginTop: "2rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                marginLeft: "1rem",
                                                marginRight: "1rem"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaInstagram */.Zf_, {
                                                id: "igIcon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                marginLeft: "1rem",
                                                marginRight: "1rem"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiFacebookCircleLine */.SpX, {
                                                id: "FbIcon"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Footer */.$_, {})
        ]
    });
}

;// CONCATENATED MODULE: ./components/pages/home/index.ts


;// CONCATENATED MODULE: ./components/pages/products/ProductPagination.tsx



function ProductPagination(param) {
    let { prevPage , nextPage , pageNumbers , changePage  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row justify-content-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "pagination",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                role: "button",
                                tabIndex: 0,
                                onKeyDown: (e)=>{
                                    e.preventDefault();
                                },
                                onClick: prevPage,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    "aria-hidden": true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaArrowCircleLeft */.MZt, {
                                        size: 20
                                    })
                                })
                            })
                        }),
                        pageNumbers.map((page)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                id: String(page),
                                "data-page": page,
                                onClick: changePage,
                                // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                                role: "button",
                                tabIndex: 0,
                                onKeyDown: (e)=>{
                                    e.preventDefault();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: page
                                })
                            }, page)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                onClick: nextPage,
                                role: "button",
                                tabIndex: 0,
                                onKeyDown: (e)=>{
                                    e.preventDefault();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    "aria-hidden": true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaArrowCircleRight */.Wgy, {
                                        size: 20
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/pages/products/Products.tsx
/* eslint-disable react/jsx-no-useless-fragment */ 





function Products() {
    const [products, setProducts] = react.useState([]);
    const [filter, setFilter] = react.useState("");
    const [currentPage, setCurrentPage] = react.useState(1);
    const [numberPerPage, setNumberPage] = react.useState(6);
    const [pageNumbers, setPageNumbers] = react.useState([]);
    const indexOfLastTodo = currentPage * numberPerPage;
    const indexOfFirstTodo = indexOfLastTodo - numberPerPage;
    const currentTodos = products.slice(indexOfFirstTodo, indexOfLastTodo);
    const productsFilter = currentTodos.filter((item)=>item.title.toLowerCase().indexOf(filter) !== -1);
    react.useEffect(function calculatePageNumbers() {
        const pages = new Array(Math.ceil(products.length / numberPerPage)).fill(0);
        setPageNumbers(pages === null || pages === void 0 ? void 0 : pages.map((_, index)=>index + 1));
    }, [
        products === null || products === void 0 ? void 0 : products.length,
        numberPerPage
    ]);
    react.useEffect(function syncProductFromDb() {
        const helper = [];
        const unsubscribe = (0,index_esm/* onValue */.jM)((0,index_esm/* ref */.iH)(firebase/* database */.Fs, "productsPoints"), (snapshot)=>{
            if (snapshot.exists()) {
                snapshot.forEach((item)=>{
                    if (item.val().status) {
                        helper.push(item.val());
                    }
                });
                setProducts(helper);
            }
        });
        return ()=>{
            if (unsubscribe) {
                unsubscribe();
            }
        };
    }, []);
    const handleChange = (e)=>{
        const { name , value  } = e.currentTarget;
        if (name === "filter") {
            setFilter(value);
        }
    };
    const changePage = (e)=>{
        e.preventDefault();
        const { page  } = e.currentTarget.dataset;
        document.getElementById("".concat(currentPage)).classList.remove("active");
        document.getElementById("".concat(page)).classList.add("active");
        setCurrentPage(Number(page));
    };
    const prevPage = (e)=>{
        e.preventDefault();
        if (currentPage !== 1) {
            document.getElementById("".concat(currentPage - 1)).classList.add("active");
            document.getElementById("".concat(currentPage)).classList.remove("active");
            setCurrentPage(currentPage - 1);
        }
    };
    const nextPage = (e)=>{
        e.preventDefault();
        if (currentPage !== pageNumbers.length) {
            document.getElementById("".concat(currentPage + 1)).classList.add("active");
            document.getElementById("".concat(currentPage)).classList.remove("active");
            setCurrentPage(currentPage + 1);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: products && products.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content-fluid",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row justify-content-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-md-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "filter",
                                            children: "Filtrar producto"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            name: "filter",
                                            value: filter,
                                            onChange: handleChange,
                                            placeholder: " ej: Ceramica",
                                            type: "text",
                                            className: "form-control"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row",
                                children: productsFilter.map((_product, id)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-4 col-md-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CardProduct */.QF, {
                                            product: _product
                                        }, id)
                                    }, id))
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPagination, {
                    prevPage: prevPage,
                    nextPage: nextPage,
                    pageNumbers: pageNumbers,
                    changePage: changePage
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            style: {
                height: "100vh"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row justify-content-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        position: "relative",
                        top: "300px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Spinner */.$j, {
                        text: "Cargando..."
                    })
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/pages/products/ProductsLayout.tsx




function UserProducts() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* UserLayout */.rf, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Products, {})
    });
}

;// CONCATENATED MODULE: ./components/pages/products/index.ts


;// CONCATENATED MODULE: ./components/pages/request/Request.tsx
/* eslint-disable no-nested-ternary */ 







function Request() {
    const [user] = (0,hooks/* useUser */.aF)();
    const [request, setRequest] = react.useState([]);
    const { currentPage , setCurrentPage , pageNumbers , items  } = (0,hooks/* usePagination */.h0)(request);
    react.useEffect(function syncRequest() {
        const _request = [];
        let unsubscribe;
        if (user === null || user === void 0 ? void 0 : user.idUser) {
            unsubscribe = (0,index_esm/* onValue */.jM)((0,index_esm/* query */.IO)((0,index_esm/* ref */.iH)(firebase/* database */.Fs, "requets"), (0,index_esm/* orderByChild */.g2)("id_user"), (0,index_esm/* equalTo */.EW)(user === null || user === void 0 ? void 0 : user.idUser)), (snapshot)=>{
                console.log(snapshot.exists());
                console.log(snapshot.val());
                if (snapshot.exists()) {
                    snapshot.forEach((child)=>{
                        _request.push({
                            ...child.val(),
                            id: child.key
                        });
                    });
                    setRequest(_request);
                }
            });
        }
        return ()=>{
            if (unsubscribe) {
                unsubscribe();
            }
        };
    }, [
        user === null || user === void 0 ? void 0 : user.idUser
    ]);
    const handleClick = (e)=>{
        e.preventDefault();
        const { page  } = e.currentTarget.dataset;
        document.getElementById("".concat(currentPage)).classList.remove("active");
        document.getElementById("".concat(page)).classList.add("active");
        setCurrentPage(Number(page));
    };
    const prevPage = (e)=>{
        if (currentPage !== 1) {
            e.preventDefault();
            document.getElementById("".concat(currentPage - 1)).classList.add("active");
            document.getElementById("".concat(currentPage)).classList.remove("active");
            setCurrentPage(currentPage - 1);
        }
    };
    const nextPage = (e)=>{
        if (currentPage !== pageNumbers.length) {
            e.preventDefault();
            document.getElementById("".concat(currentPage + 1)).classList.add("active");
            document.getElementById("".concat(currentPage)).classList.remove("active");
            setCurrentPage(currentPage + 1);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* UserLayout */.rf, {
        children: request && request.length > 0 && items && items.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row justify-content-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "card",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "card-content table-responsive table-full-width",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                    className: "table table-striped",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-center",
                                                            children: "FECHA"
                                                        })
                                                    }, "date"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-center",
                                                            children: "TIENDA"
                                                        })
                                                    }, "store"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-center",
                                                            children: "ESTATUS"
                                                        })
                                                    }, "status"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-center",
                                                            children: "NUMERO DE ORDEN"
                                                        })
                                                    }, "number_bill")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                            children: items.map((_request)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "text-center",
                                                            children: _request.date
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "text-center",
                                                            children: _request.store.toUpperCase()
                                                        }),
                                                        _request.status === "rechazado" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "text-center",
                                                            style: {
                                                                color: "red"
                                                            },
                                                            children: _request.status.toUpperCase()
                                                        }) : _request.status === "procesando" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "text-center",
                                                            style: {
                                                                color: "grey"
                                                            },
                                                            children: _request.status.toUpperCase()
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "text-center",
                                                            style: {
                                                                color: "green"
                                                            },
                                                            children: _request.status.toUpperCase()
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "text-center",
                                                            children: _request.number_bill
                                                        })
                                                    ]
                                                }, _request.id))
                                        })
                                    ]
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row justify-content-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "card-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "pagination",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            role: "button",
                                            tabIndex: 0,
                                            onClick: prevPage,
                                            onKeyDown: (e)=>{
                                                e.preventDefault();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                "aria-hidden": true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaArrowCircleLeft */.MZt, {
                                                    size: 20
                                                })
                                            })
                                        })
                                    }),
                                    pageNumbers.map((page)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            id: String(page),
                                            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                                            role: "button",
                                            tabIndex: 0,
                                            "data-page": page,
                                            onClick: handleClick,
                                            onKeyUp: (e)=>{
                                                e.preventDefault();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: page
                                            })
                                        }, page)),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            role: "button",
                                            tabIndex: 0,
                                            onClick: nextPage,
                                            onKeyDown: (e)=>{
                                                e.preventDefault();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                "aria-hidden": true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaArrowCircleRight */.Wgy, {
                                                    size: 20
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row justify-content-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-lg-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "text-center",
                            children: "No hay ninguna solicitud registrada."
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row justify-content-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/user/exchange",
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn btn-default",
                            style: {
                                position: "relative",
                                left: "1.5%"
                            },
                            type: "button",
                            children: "Realizar solicitud"
                        })
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/pages/request/index.ts


;// CONCATENATED MODULE: ./components/pages/user/UserProfile.tsx




function UserProfile() {
    const [user] = (0,hooks/* useUser */.aF)();
    var _user_answer;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* UserLayout */.rf, {
        children: user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-lg-4 col-md-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CardProfile */.QJ, {
                        user: user
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-lg-8 col-md-7",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* EditProfile */.JI, {})
                }),
                ((_user_answer = user === null || user === void 0 ? void 0 : user.answer) !== null && _user_answer !== void 0 ? _user_answer : "") ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-lg-12 col-md-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* InfoExtra */.et, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-md-4 col-sm-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CreditCard */.aB, {
                        name: user === null || user === void 0 ? void 0 : user.firstName,
                        lastName: user === null || user === void 0 ? void 0 : user.firstLastname,
                        email: user === null || user === void 0 ? void 0 : user.email
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            style: {
                height: "100vh"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row justify-content-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        position: "relative",
                        top: "300px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Spinner */.$j, {
                        text: "Cargando..."
                    })
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/pages/user/index.ts


;// CONCATENATED MODULE: ./components/pages/index.ts








/***/ })

}]);